module.exports = __webpack_public_path__ + "static/media/add.24122f57.svg";